import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import classes from './SideBar.css';
import SideBarItems from './SideBarItems/SideBarItems';
import CountrySelector from './CountrySelector/CountrySelector';

const sideBar = props => {
  const {
    country,
    language,
    opened,
    closeSideBar,
    selectedCanadaEN,
    selectedCanadaFR,
    selectedUSA
  } = props;

  return (
    <Fragment>
      <div className={opened ? classes.SideBarOpened : classes.SideBarClosed}>
        <SideBarItems closeSideBar={closeSideBar} language={language} />
        <CountrySelector
          closeSideBar={closeSideBar}
          selectedCanadaEN={selectedCanadaEN}
          selectedCanadaFR={selectedCanadaFR}
          selectedUSA={selectedUSA}
          country={country}
          language={language}
        />
      </div>
      <div
        className={opened ? classes.Overlay : classes.SideBarClosed}
        onClick={closeSideBar}
      />
    </Fragment>
  );
};

sideBar.propTypes = {
  language: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  opened: PropTypes.bool,
  closeSideBar: PropTypes.func.isRequired,
  selectedCanadaEN: PropTypes.func.isRequired,
  selectedCanadaFR: PropTypes.func.isRequired,
  selectedUSA: PropTypes.func.isRequired
};

export default withRouter(sideBar);
